import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useSelectBrandId from "#features/Giftcard/hooks/useSelectBrand";
import useSelectBrand from "#hooks/styles/useSelectBrand";
import useReactGASend from "../../hooks/useReactGASend";
import React from "react";


const introText = `유실물은 인천SSG랜더스필드 랜더스센터에 습득된 경우에 한하여 확인이 가능합니다.

SSG랜더스 상담센터 또는 SSG랜더스 APP 1:1 문의를 통해 분실 일자와 분실물의 특징(색상, 브랜드, 모양 등)을 남겨주시면, 확인 후 안내 도와드리겠습니다.

(예시)
9/19 빨간색 카드지갑, 내용물(신용카드, 운전면허증(김랜디))

※ 습득된 유실물은 랜더스센터에 습득된 경우에만 확인 가능하며, 습득 후 30일간 보관됩니다.
*30일 초과된 유실물은 폐기, 또는 경찰서 유실물 센터로 인계될 수 있습니다.
※ 유실물의 습득 확인 시 홈경기일 경기장 입장 가능시간에 랜더스센터에서 수령 가능합니다.

랜더스센터 정보
- 위치 : 인천SSG랜더스필드 내 의무실 앞(107 섹션 앞)
경기장 내 위치해 있어 입장을 위해서는 당일 경기 티켓이 필요합니다.
- 운영시간 : 홈경기일 게이트 오픈시간~경기종료 시`;

const common = [
  {
    title: "분실물은 어떻게 신고하나요?",
    content:
      "인천SSG랜더스필드 내에서 습득된 유실물은 랜더스센터에서 보관하고 있습니다.\nSSG랜더스 고객센터 또는 SSG랜더스 APP 1:1 문의를 통해 분실 일자와 분실물의 특징(색상, 브랜드, 모양 등)을 남겨주시면, 확인 후 안내 도와드리겠습니다.\n\n(예시) 9/19 빨간색 카드지갑, 내용물(신용카드, 운전면허증(김랜디))\n\n※ 유실물은 랜더스센터에 습득된 경우에만 확인 가능하며, 습득일로부터 30일간 보관됩니다.\n*습득일로부터 30일이 초과된 유실물은 폐기, 또는 경찰서 유실물 센터로 인계될 수 있습니다.\n\n랜더스센터 정보\n- 위치 : 인천SSG랜더스필드 내 의무실 앞(107 섹션 앞). 경기장 내 위치해 있어 입장을 위해서는 당일 경기 티켓이 필요합니다.\n- 운영시간 : 홈경기일 게이트 오픈시간~경기종료 시",
  },
  {
    title: "습득 확인된 분실물은 어떻게 찾나요?",
    content:
      "랜더스 상담센터 또는 SSG랜더스 APP 1:1문의를 통해 확인된 유실물은 인천SSG랜더스필드 내 위치한 랜더스센터에서 찾으실 수 있습니다.\n※ 랜더스센터 정보\n- 위치 : 인천SSG랜더스필드 내 의무실 앞(107 섹션 앞). 경기장 내 위치해 있어 입장을 위해서는 당일 경기 티켓이 필요합니다.\n- 운영시간 : 홈경기일 게이트 오픈시간~경기종료 시\n\n※ 습득일로부터 30일 이내 찾아가지 않을 시 폐기, 또는 경찰서 유실물 센터로 인계될 수 있습니다.\n※ 홈경기 미진행, 또는 경기장 개문시간 이전 및 경기 종료 이후에는 유실물 수령이 어렵습니다.",
  },
];


export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      <p className="font-medium text-gray-950 whitespace-pre-line">{item.content}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map(button => (
            <LinkItem
              title={button.title}
              url={button.link}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-12 rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const LostFoundPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="분실물" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950 whitespace-pre-line">
        {introText}
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("분실물_전화상담")}
        />
      </div>
    </section>
  );
};

export default LostFoundPage;
